import React from 'react';
import logo from './logo.svg';
import './App.css';
import proverbs from './data/proverbs.json';
import james from './data/james.json';

class QuestionModel {

	constructor(grownUpMode, questionMode) {
		if (!questionMode) {
			questionMode= "proverbs";
		}
		this.correctIndex = -1;
		this.grownUpMode = grownUpMode;
		this.questionMode = questionMode;
	}
	
	randomNumber(min, max) {  
		return Math.floor(Math.random() * (max - min) + min); 
	} 
	
	getQuestionCount() {
		return proverbs.Questions.length;
	}
	
	getQuestionPool(mode) {
		var questionPool = [];
		if (mode.includes("proverbs") || (mode.includes("all"))) {
			questionPool = questionPool.concat(proverbs.Questions);
		}
		if (mode.includes("james") || (mode.includes("all"))) {
			questionPool = questionPool.concat(james.Questions);
		}
		return questionPool;
	}
	
	getVerseByReference(ref) {
		var questionPool = this.getQuestionPool(this.questionMode);
		
		for(var i = 0; i < questionPool.length; i++ ) {
			var question = questionPool[i];
			if (question.Reference === ref) {
				var verseText = question.Text;
				verseText = verseText.replace('bbb', question.Answer1 );
				verseText = verseText.replace('Bbb', question.Answer1);
				return verseText;
			}
		}
		return null;
	}

	getRandomQuestion() {
		var questionPool = this.getQuestionPool(this.questionMode);
		
		var randomNum = null;
		var randomQuestion = null;
		var questionInRange = false;
		
		while (!questionInRange) {
			randomNum = this.randomNumber(0, questionPool.length - 1);
			console.log("Trying question at: " + randomNum);
			randomQuestion = questionPool[randomNum];
			questionInRange = true;
			if(!this.grownUpMode) {
				if (randomQuestion.Tags && 
					(randomQuestion.Tags.includes("adult") 
					|| (randomQuestion.Tags.includes("Adult"))
					|| (randomQuestion.Tags.includes("sex"))
					|| (randomQuestion.Tags.includes("Sex"))
					)) {
					questionInRange = false;
				}
			}
		}
		
		var correctIndex = this.randomNumber(0, 4);
		//alert('^^ created correctIndex of ' + correctIndex);
		if (correctIndex === 0) {
			randomQuestion.displayOne = randomQuestion.Answer1;
			randomQuestion.displayTwo = randomQuestion.Answer2;
			randomQuestion.displayThree = randomQuestion.Answer3;
			randomQuestion.displayFour = randomQuestion.Answer4;
			//alert('answer should be ' + randomQuestion.displayOne);
		} else if (correctIndex === 1) {
			randomQuestion.displayOne = randomQuestion.Answer4;
			randomQuestion.displayTwo = randomQuestion.Answer1;
			randomQuestion.displayThree = randomQuestion.Answer2;
			randomQuestion.displayFour = randomQuestion.Answer3;
			//alert('answer should be ' + randomQuestion.displayTwo);
		} else if (correctIndex === 2) {
			randomQuestion.displayOne = randomQuestion.Answer3;
			randomQuestion.displayTwo = randomQuestion.Answer4;
			randomQuestion.displayThree = randomQuestion.Answer1;
			randomQuestion.displayFour = randomQuestion.Answer2;
			//alert('answer should be ' + randomQuestion.displayThree);
		} else if (correctIndex === 3) {
			randomQuestion.displayOne = randomQuestion.Answer2;
			randomQuestion.displayTwo = randomQuestion.Answer3;
			randomQuestion.displayThree = randomQuestion.Answer4;
			randomQuestion.displayFour = randomQuestion.Answer1;
			//alert('answer should be ' + randomQuestion.displayFour);
		}
		randomQuestion.correctIndex = correctIndex;
		console.log("Answer is: " + randomQuestion.Answer1);
		console.log("Question is: " + randomQuestion.Text);
		return randomQuestion;
	}
}

export default QuestionModel;
